import { useQuery } from '@tanstack/react-query';
import initData from '../remote_config.json';

// PR-BUG.1: Cloudflare Pages (and most SPA hosts) serve an HTML 404 page when
// REMOTE_CONFIG_URL points at a missing path. `response.ok` is still true for
// 200-OK CDN catch-all pages, so `response.json()` then throws
// `SyntaxError: Unexpected token '<', "<!DOCTYPE "... is not valid JSON`
// and surfaces in the browser console on every reload.
//
// Remote config is non-critical bootstrap data — `initialData` in the
// useQuery hook is the canonical fallback. Make the queryFn resilient by:
// 1. Skipping the fetch entirely when REMOTE_CONFIG_URL is unset (was a
//    hard throw in prod, which blocked the query from settling).
// 2. Validating Content-Type before parsing — reject HTML responses
//    cleanly even when the HTTP status looks healthy.
// 3. Swallowing all parse / network errors and returning `initData` so the
//    consumer always has a usable value.
const remoteConfigQuery = async function () {
    const REMOTE_CONFIG_URL = process.env.REMOTE_CONFIG_URL || '';
    if (!REMOTE_CONFIG_URL) return initData;

    try {
        const response = await fetch(REMOTE_CONFIG_URL);
        if (!response.ok) return initData;

        const contentType = response.headers.get('content-type') || '';
        if (!contentType.toLowerCase().includes('application/json')) return initData;

        return await response.json();
    } catch {
        return initData;
    }
};

function useRemoteConfig() {
    return useQuery({
        queryKey: ['remoteConfig'],
        queryFn: remoteConfigQuery,
        initialData: initData,
    });
}

export default useRemoteConfig;
